import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { keys } from 'hooks/incident/useRoster';
import { selectGroupGuid, useAppSelector } from 'slices/commonSelectors';

export const useUpdateHomeAor = () => {
  const queryClient = useQueryClient();
  const groupGuid = useAppSelector(selectGroupGuid);

  return useMutation({
    mutationFn: async ({ homeAor }: { homeAor: string | null }) => {
      const response = await axios.post(config.apiGateway.updateHomeAor, {
        homeAor,
        groupGuid,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [keys.groupRosters, groupGuid],
      });
    },
  });
};
